var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app", attrs: { id: "app" } },
    [
      _c("app-refresh"),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("app-toaster"),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "app-modal" } }),
      _vm._v(" "),
      _c("vue-up"),
      _vm._v(" "),
      _c("features-pub-modal", { on: { close: _vm.switchWelcomeWesave } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }